import { gql } from 'apollo-angular';

const CHANGE_TIER = gql`
  mutation changeTier($activePurchasePlan: Long!, $offerId: Long!, $tierId: Long!) {
    changeTier(
      tierChangeRequest: {
        activePurchasePlan: $activePurchasePlan
        tierSelectionOptions: { offerId: $offerId, tierId: $tierId }
        changeTierOperation: CHANGE_PRICE
      }
    ) {
      updated
    }
  }
`;

export default CHANGE_TIER;
